













import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GModalBase',
  props: {
    onClose: { type: Function as PropType<() => void>, default: null },
  },
  created() {
    // モーダルが開いた時にWebPageをスクロールできないようにする
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
  },
  beforeDestroy() {
    // モーダルが開いた時にWebPageをスクロールできないようにする状態を解除
    const top = parseInt(document.body.style.top, 10);
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    window.scrollTo(window.scrollX, (top || 0) * -1);
  },
});
